export enum CreditType {
  DAE = 'DAE',
  LTO = 'LTO',
}

export enum CreditTypeId {
  DAE = '9',
  LTO = '1',
}
